import { render, staticRenderFns } from "./headerData.vue?vue&type=template&id=637ed336&scoped=true"
import script from "./headerData.vue?vue&type=script&lang=js"
export * from "./headerData.vue?vue&type=script&lang=js"
import style0 from "./headerData.vue?vue&type=style&index=0&id=637ed336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ed336",
  null
  
)

export default component.exports